import { Component, OnInit, Inject, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ManikEntityFE, CookieManager } from 'src/app/manik-library/ManikEntityFE';
import { IRateAndReview, RateAndReviewModel } from 'src/app/models/web-card-model';
import { ManikEntityService } from 'src/app/manik-library/ManikEntityService';
declare const $: any;
declare const grecaptcha: any;
@Component({
  selector: 'rate-and-review',
  templateUrl: './rate-and-review.component.html',
  styleUrls: ['./rate-and-review.component.scss']
})
export class RateAndReviewComponent extends ManikEntityFE implements OnInit, OnChanges {
  BusinessCategoryID: string = "";
  RatingComputedParams: IRateAndReview[] = [];
  RateAndReviewList: any[] = [];
  RatingStarCount: number = 0;
  RateReviewContext: any;
  RNRModel: RateAndReviewModel = new RateAndReviewModel();
  WebSiteMetaData: any = JSON.parse(sessionStorage.getItem("SiteMetaData"));
  RateNReviewRecaptcha: any;
  CaptchaInvalid: boolean = false;
  CaptchaMessage: string = '';
  UserLoggedIn: boolean;
  BranchList: any[] = [];
  @Input() VisitorData: any;
  @Output() VisitorLoggedIn = new EventEmitter();
  constructor(public _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document: any) {
    super(document);
  }

  ngOnInit() {
    this.BusinessCategoryID = this.WebSiteMetaData.CID;
    this.RNRModel.BusinessName = this.WebSiteMetaData.Title;
    this.populateControls();
    this.CheckUserLoggedIn();
  }

  ngOnChanges() {
    this.CheckUserLoggedIn();
  }

  populateControls(): void {
    this.updateFilterParams(this.BusinessCategoryID);
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null, this.prepareAddlQueryHeaders2("ULTRA.QUICK", "GET.RATING.PARAMS", "PORTAL"))
      .subscribe(data => {
        this.RateReviewContext = data.ManikJSon[0].JSon0[0];
        this.RNRModel.OverallRatingText = this.RateReviewContext.OverallRatingText;
        this.RateAndReviewList = data.ManikJSon[0].JSon1;
        this.RateAndReviewList.forEach(item => {
          this.RatingComputedParams.push({ "ID": item.RatingParamID, "IsSelected": "N" });
        });
      });
    this.updateFilterParams(this.WebSiteMetaData.BID);
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null, this.prepareAddlQueryHeaders2("GET.BRANCHES", "BUSINESS.BRANCH", "BIZ","EMCITY"))
      .subscribe(data => {
        console.log(data);
        this.BranchList = data.ManikJSon[0].JSon1;
        if (!data.ManikJSon[0].JSon0[0].NoOfBranches) {
          this.RNRModel.BusinessBranchID = '0';
        }
      });
  }


  Emit() {
    this.VisitorLoggedIn.emit('Y');
  }
  CaptchaInitialized: boolean = false;
  CheckUserLoggedIn() {
    if (CookieManager.getCookie('VisitorData')) {
      let x = JSON.parse(CookieManager.getCookie('VisitorData'));
      if (x) {
        if (x.VisitorName) {
          this.UserLoggedIn = true;
        
          this.RNRModel.ReviewerName = x.VisitorName;
          this.RNRModel.ReviewerEmailID = x.EmailID;
          this.RNRModel.ReviewerMobile = x.MobileNumber;
          setTimeout(() => {
          if (!this.CaptchaInitialized) {
            this.InitCaptcha(this.RateNReviewRecaptcha, 'rNrForm', grecaptcha);
            this.CaptchaInitialized = true;
          }
          }, 1000)
        }
        else {
          this.UserLoggedIn = false;
        }
      }
      else {
        this.UserLoggedIn = false;
      }
    }
  }


  refreshDataGrid(param: any): void {
  }

  OnRatingOptionClick(RatingID: number, event): void {
    for (var i = 0; i < this.RatingComputedParams.length; i++) {
      if (this.RatingComputedParams[i].ID === RatingID) {
        this.RatingComputedParams[i].IsSelected = event.checked ? "Y" : "N";
      }
    }
  }

  BindRatingImageOnSelect(RatingStar: number) {
    switch (RatingStar) {
      case 5:
        this.RNRModel.StarHeaderText = this.RateReviewContext.FiveStarHeader;
        this.RNRModel.StarText = this.RateReviewContext.FiveStarText;
        this.RNRModel.StarImageUrl = '/images/excellent.png';
        this.RatingStarCount = 5;
        break;
      case 4:
        this.RNRModel.StarHeaderText = this.RateReviewContext.FourStarHeader;
        this.RNRModel.StarText = this.RateReviewContext.FourStarText;
        this.RNRModel.StarImageUrl = '/images/happy.png';
        this.RatingStarCount = 4;
        break;
      case 3:
        this.RNRModel.StarHeaderText = this.RateReviewContext.ThreeStarHeader;
        this.RNRModel.StarText = this.RateReviewContext.ThreeStarText;
        this.RNRModel.StarImageUrl = '/images/avrage.png';
        this.RatingStarCount = 3;
        break;
      case 2:
        this.RNRModel.StarHeaderText = this.RateReviewContext.TwoStarHeader;
        this.RNRModel.StarText = this.RateReviewContext.TwoStarText;
        this.RNRModel.StarImageUrl = '/images/sad.png';
        this.RatingStarCount = 2;
        break;
      case 1:
        this.RNRModel.StarHeaderText = this.RateReviewContext.OneStarHeader;
        this.RNRModel.StarText = this.RateReviewContext.OneStarText;
        this.RNRModel.StarImageUrl = '/images/sad.png';
        this.RatingStarCount = 1;
        break;
    }
  }

  SubmitRateAndReview(): void {
    this.CaptchaInvalid = false;
    this.CaptchaMessage = '';
    let x = grecaptcha.getResponse(this.RateNReviewRecaptcha);
    this._manikEntityService.manikEntityConnect2('WebSite/captcha/v2?sToken=' + x, null, null)
      .subscribe(data => {
        if (data.success) {
          this.SubmitForm();
        }
        else {
          this.CaptchaInvalid = true;
          if (data['error-codes'].find(item => {
            return item == 'missing-input-response'
          })) {
            this.CaptchaMessage = 'Please click on the checkbox';
          }
          if (data['error-codes'].find(item => {
            return item == 'timeout-or-duplicate'
          })) {
            this.CaptchaMessage = 'Please click on the checkbox again';
          }

        }
      });
  }

  SubmitForm() {
    this.RNRModel.SubmittedRNR = true;
    let SelectedParams = "";
    let NotSelectedParams = "";
    this.RatingComputedParams.forEach(item => {
      if (item.IsSelected === "Y")
        SelectedParams += SelectedParams ? "_" + item.ID : item.ID;
      else
        NotSelectedParams += NotSelectedParams ? "_" + item.ID : item.ID;
    });
    let body = {
      "BusinessHandle": this.WebSiteMetaData.BizHandle,
      "PortalID": this.WebSiteMetaData.PID,
      "Review": this.RNRModel.UserReviewText,
      "StarRating": this.RatingStarCount,
      "ChannelID": "W",
      "SelectedParams": SelectedParams,
      "NotSelectedParams": NotSelectedParams,
      "IsVerified": 'Y',
      "ReviewerName": this.RNRModel.ReviewerName,
      "ReviewerEmailID": this.RNRModel.ReviewerEmailID,
      "ReviewerMobile": this.RNRModel.ReviewerMobile,
      "BusinessBranchID": this.RNRModel.BusinessBranchID
    };
    let SubmittedData = JSON.stringify({ "items": [body] });

    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", SubmittedData, this.prepareManageHeaders2("A", "BUSINESSECOSYSTEM.REVIEW", "BIZ"))
      .subscribe(data => {
        let id = data.ManikJSon[0].JSon0[0].NewEntity;
        this.RNRModel.SubmittedRNR = false;
        this.RNRModel= {
          BusinessName: "",
          OverallRatingText:  "",
          StarHeaderText:  "",
          StarText:  "",
          StarImageUrl:  "",
          UserReviewText:  "",
        SubmittedRNR: false,
        ReviewerName:  '',
        ReviewerEmailID:  '',
        ReviewerMobile:  '',
        BusinessBranchID:  '',
      }


        $("#lbl2RMessage").text("Your request has been submitted!");
        $("#lbl2RMessage").show();
        setTimeout(() => {
          $("#lbl2RMessage").hide();
          $('#RateBusiness').modal('hide');
        }, 2000);
      }
      ,err=>{
        this.RNRModel.SubmittedRNR = false;
      });
  }

}
